import { Loader2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const AnalyzingStep = ({ preview, onCancel }) => (
  <Card className="shadow-sm fade-in" data-testid="analyzing-panel">
    <CardContent className="p-8 space-y-4">
      <div className="flex items-center gap-3">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
        <h2 className="text-2xl font-serif font-semibold">Checking your file…</h2>
      </div>
      <p className="text-sm text-muted-foreground" data-testid="analyzing-detail">
        {preview?.row_count ? `${preview.row_count.toLocaleString()} rows in ${preview.filename}. ` : ""}
        We're grouping orders and matching them to existing supporters. Larger files can take a minute or two —
        you can stay on this page.
      </p>
      <Button variant="outline" onClick={onCancel} data-testid="analyzing-cancel-btn">Cancel</Button>
    </CardContent>
  </Card>
);
